/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServeRpc
 */
import * as References from './SelfServeRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServeRpc#getSearchRequestForCollection
 */
export const GET_SEARCH_REQUEST_FOR_COLLECTION_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_quality_rpc_SelfServeRpc_getSearchRequestForCollection';
export const GET_SEARCH_REQUEST_FOR_COLLECTION_QUERY: RegisteredQuery<
  'result',
  References.GetSearchRequestForCollectionRequestType,
  References.GetSearchRequestForCollectionResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SEARCH_REQUEST_FOR_COLLECTION_QUERY_FIELD_NAME,
  args: ['collectionId', 'published', 'language'],
  fetcher(
    request: References.GetSearchRequestForCollectionRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSearchRequestForCollectionResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSearchRequestForCollectionRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServeRpc#getAllPublishedCollections
 */
export const GET_ALL_PUBLISHED_COLLECTIONS_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_quality_rpc_SelfServeRpc_getAllPublishedCollections';
export const GET_ALL_PUBLISHED_COLLECTIONS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetAllPublishedCollectionsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_ALL_PUBLISHED_COLLECTIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAllPublishedCollectionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAllPublishedCollectionsRpc,
      { timeout: ctx.timeout }
    );
  },
});
